<template>
  <q-card
    flat
    :class="$q.dark.mode ? 'bg-grey-10' : 'bg-grey-1'"
    class="q-mt-xs q-px-md text-center"
    @click="$router.push({ path: '/nepse-live-market' })"
  >
    <marquee class="cursor-pointer" behavior="" direction="left">
      <span
        v-for="item in liveMarketData"
        :key="item"
        class="q-mr-md text-bold"
      >
        <span :class="$q.dark.mode ? '' : 'text-grey-10'" class="q-mr-sm">
          {{ item[0] }}
        </span>
        <span :class="$q.dark.mode ? '' : 'text-grey-9'">
          {{ item[1] }}
        </span>
        <span :class="$q.dark.mode ? '' : 'text-grey-8'">
          ({{ item[3] }})
        </span>
        <span
          class="q-mr-x"
          :class="
            item[2] < 0 ? 'text-red' : item[2] == 0 ? 'text-blue' : 'text-green'
          "
        >
          ({{ item[2]?.toFixed(2) }})
          <q-icon
            size="xs"
            :name="
              item[2] < 0
                ? 'keyboard_arrow_down'
                : item[2] == 0
                ? 'code'
                : 'keyboard_arrow_up'
            "
          />
        </span>
      </span>
    </marquee>
  </q-card>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { LocalStorage, useQuasar } from "quasar";
import useData from "src/use/data";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const $q = useQuasar();
const store = useStore();
const $router = useRouter();
const { stockSummary } = useData();

const isMarketOn = ref(LocalStorage.getItem("isMarketOn"));
const liveMarketData = ref([]);

const loadData = async () => {
  try {
    const res = await stockSummary();
    liveMarketData.value = res.data;
  } catch (error) {
    console.error("Error fetching live market data:", error);
  }
};

onMounted(() => {
  loadData();
  // if (isMarketOn.value) {
  //   setInterval(() => {
  //     loadData();
  //   }, 60000);
  // }
});
</script>
